document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-cat-carousel]').forEach(function (section) {
    var track = section.querySelector('[data-cat-track]');
    var prevBtn = section.querySelector('.cat-carousel__arrow--prev');
    var nextBtn = section.querySelector('.cat-carousel__arrow--next');
    if (!track) return;

    function scrollByCard(direction) {
      var slide = track.querySelector('.cat-carousel__slide');
      if (!slide) return;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      var amount = (slide.getBoundingClientRect().width + gap) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      var canScroll = track.scrollWidth > track.clientWidth + 2;

      if (!canScroll) {
        prevBtn.setAttribute('data-disabled', 'true');
        nextBtn.setAttribute('data-disabled', 'true');
        return;
      }

      prevBtn.setAttribute('data-disabled', track.scrollLeft <= 0 ? 'true' : 'false');
      nextBtn.setAttribute('data-disabled', track.scrollLeft >= maxScroll ? 'true' : 'false');
    }

    track.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  });
});